import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Observable, of} from 'rxjs';
import {catchError} from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ManagedSettingsService {

  constructor(private http: HttpClient) {
  }

  getValue(key: string): Observable<string> {
    const headers = new HttpHeaders({Accept: 'text/plain'});

    return this.http.get(`api/security/user/managed-settings/${key}`, {
      headers,
      responseType: 'text'
    })
      .pipe(catchError(err => {
        return of('error retrieving content');
      }));
  }

  setValue(key: string, value: string): Observable<void> {
    if (value === 'error retrieving content') {
      throw new Error('error saving error message as content');
    }
    value = value.replace(/\n/g, '\\n');
    value = value.replace(/"/g, '\\"');
    return this.http.post<void>('api/managed-settings/' + key, value);
  }
}
